import "./Footer.css";
import logo from "../assets/footer-logo.png";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import { useState } from "react";
import emailjs from "emailjs-com";

function Footer() {
  const [email, setEmail] = useState("");

    const handleSubscribe = (e) => {
      e.preventDefault();

      emailjs.send(
        "service_xhtcsx3",      // ✅ Service ID
        "template_lfmdog7",     // ✅ Template ID
        {
          email: email,                             // ✅ matches {{email}}
          name: email.split("@")[0],                // ✅ auto-generate name from email
          date: new Date().toLocaleDateString(),    // ✅ matches {{date}}
        },
        "jU5P_1RatrK_Zn_eW"     // ✅ Public Key
      )
      .then(() => {
        alert("Faleminderit! Ju u abonuat me sukses në Probioma 🌿");
        setEmail(""); // clear input
      })
      .catch((err) => {
        console.error("EmailJS Error:", err);
        alert("Na vjen keq, pati një problem me abonimin.");
      });
    };

  return (
    <footer className="probioma-footer">
      <div className="footer-container">
        
        {/* Left: Logo + tagline */}
        <div className="footer-left">
          <img src={logo} alt="Probioma Logo" className="footer-logo" />
          <p className="tagline">Fabrika ku lind një stil jete</p>
        </div>

        {/* Center: Social Icons */}
        <div className="footer-center">
          <div className="footer-socials">
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FaFacebook />
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer">
              <FaTiktok />
            </a>
          </div>
        </div>

        {/* Right: Newsletter */}
        <div className="footer-right">
          <p className="newsletter-text">
            Abonohu për të rejat më të fundit & ofertat speciale
          </p>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Email-i juaj"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit">Abonohu</button>
          </form>
        </div>

      </div>

      {/* Bottom note */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Probioma. All rights reserved.</p>
        <p>
          Brewed with passion in Albania |{" "}
          <a href="mailto:info@probioma.al">info@probioma.al</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
